/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type SetTracingContactAssessmentResultDtoResult =
  (typeof SetTracingContactAssessmentResultDtoResult)[keyof typeof SetTracingContactAssessmentResultDtoResult];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetTracingContactAssessmentResultDtoResult = {
  // NOT_NEEDED: 'NOT_NEEDED',
  // INDETERMINATE: 'INDETERMINATE',
  // POSITIVE: 'POSITIVE',
  // NEGATIVE: 'NEGATIVE',
  NO_UU_NEEDED: 'NO_UU_NEEDED',
  INFECTED: 'INFECTED',
  NOT_INFECTED: 'NOT_INFECTED',
  SICK: 'SICK',
  NOT_SHOW_UP: 'NOT_SHOW_UP',
  REFUSED_TEST: 'REFUSED_TEST',
  GONE_HIDING: 'GONE_HIDING',
  STATUS_AFTER_TB: 'STATUS_AFTER_TB',
  STATUS_AFTER_TBI: 'STATUS_AFTER_TBI'
} as const;
